export default class ReceiveBuffer {
  constructor() {
    this.packetsQueue = [];
  }

  static packets(buffer) {
    let offset = 0;
    let packets = [];
    while (offset < buffer.byteLength) {
      const int32ByteLength = 4;
      const partLengthStart = offset;
      const partLengthEnd = offset + int32ByteLength;
      const partLength = buffer.readInt32BE(partLengthStart);
      const partData = buffer.slice(partLengthEnd, partLengthEnd + partLength);

      packets.push({
        data: partData
      });

      offset = partLengthEnd + partLength;
    }
    return packets;
  }

  append(buffer) {
    const packets = ReceiveBuffer.packets(buffer);

    for (const packet of packets) {
      this.packetsQueue.push(packet);
      if (this.packetsQueue.length > 16) {
        this.packetsQueue.shift();
      }
    }
  }

  read() {
    if (this.packetsQueue.length === 0) {
      return null;
    }
    return this.packetsQueue.shift();
  }

  clear() {
    this.packetsQueue = [];
  }
}
